/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Error - Media import failed" |
*
* @param {Team_Project_Import_Media_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_import_failed = /** @type {((inputs?: Team_Project_Import_Media_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur - Échec de l’importation du média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler – Medienimport fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore - Importazione del supporto non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка - Не удалось импортировать медиафайлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error: Error en la importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误 - 媒体导入失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー - メディアのインポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि - मीडिया आयात विफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro - Falha na importação de mídia")
	return /** @type {LocalizedString} */ ("Error - Media import failed")
});